import { useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import DashboardCards from './DashboardCards';
import FromAndToDatePicker from '../../../components/mui/FromAndToDatePicker';
import Stack from '@mui/material/Stack';
import DashboardFilters from './DashboardFilters';
import GlobalTable from '../../../components/CustomTableWithPagination/GlobalTable';
import { LeadDetailsFn } from './utils/headerJson';
import dayjs from 'dayjs';
import CsdFooterGraphAndTable from './CsdFooterGraphAndTable';
import { setTableSearch } from '../../../redux/features/CRDslice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import OgdFooterTableLanding from './OgdFooterTableLanding';

export default function OgdCsdDashboard({ CSD }) {
  const [fromDate, setFromDate] = useState(dayjs().startOf('year').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('year').format('YYYY-MM-DD'));
  const dispatch = useDispatch();
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  const leadExpenseCSDTable = useSelector((state) => state.crd.leadExpenseCSDTable.data);
  const leadExpenseCSDTableMeta = useSelector((state) => state.crd.leadExpenseCSDTable.meta);
  const leadExpenseCSDTableLoading = useSelector((state) => state.crd.leadExpenseCSDTable.loading);

  useEffect(() => {
    dispatch(
      setTableSearch({
        key: 'leadExpenseCSDTable',
        value: {
          page: tableState?.page,
          limit: tableState?.pageSize,
          search: tableState?.search,
        },
      }),
    );
  }, [tableState?.search, tableState?.page, tableState?.pageSize, tableState?.sort, dispatch]);

  const LeadDetails = useMemo(() => LeadDetailsFn(CSD), [CSD]);

  return (
    <GlobalWrapper
      title={CSD ? 'CSD Dashboard' : 'OGD Dashboard'}
      actions={
        <FromAndToDatePicker
          fromDate={fromDate}
          toDate={toDate}
          fromLabel="From Date"
          toLabel="To Date"
          setFromDate={setFromDate}
          setToDate={setToDate}
        />
      }
    >
      <Stack gap={2}>
        <DashboardFilters fromDate={fromDate} toDate={toDate} CSD={CSD} />
        <DashboardCards CSD={CSD} />
        <GlobalTable
          headers={LeadDetails}
          rows={leadExpenseCSDTable}
          rowUniqueId="sl_no"
          meta={leadExpenseCSDTableMeta}
          loading={leadExpenseCSDTableLoading}
          tableState={tableState}
          setTableState={setTableState}
        />
        {CSD ? <CsdFooterGraphAndTable /> : <OgdFooterTableLanding />}
      </Stack>
    </GlobalWrapper>
  );
}
